// extracted by mini-css-extract-plugin
export default {"wrapper":"TasksForm_wrapper__LJO-l","container":"TasksForm_container__MZs5B","icons":"TasksForm_icons__DLUjd","drop-down-icon":"TasksForm_drop-down-icon__Ku0z9"};